import axios from "axios";
import { toast } from "sonner";

// Create axios instance
const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
    },
});

// Request interceptor to add token
apiClient.interceptors.request.use(
    (config) => {
        // 1. Check if the request explicitly says "No Auth"
        if (config.isProtected === false) {
            return config;
        }

        // 2. Otherwise, attach token (Default behavior)
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor (optional: for global error handling)
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle Network Errors
        if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
            toast.error("Please check your internet connection. Your internet is not connected.");
        }

        // Handle 401 (Unauthorized) globally
        if (error.response && error.response.status === 401) {
            // Check if the request specifically asked to skip the redirect
            if (error.config?.skipAuthRedirect) {
                return Promise.reject(error);
            }
            sessionStorage.clear();
            localStorage.removeItem("token");
            localStorage.removeItem("emailVerify");
            localStorage.removeItem("phoneVerify");
            localStorage.removeItem("currentUser");
            localStorage.removeItem("loginTimestamp");
            localStorage.setItem("loggedOut", "true"); // Sync with other tabs if listener exists

            // Redirect to login
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export default apiClient;
